export default {
  setting: {
    // id: 'ir.sikapp.sikatech', // App bundle ID
    // name: 'SikaTech', // App name
    theme: 'ios', // Automatic theme detection
    dialog: {
      buttonOk: "قبول",
      buttonCancel: "انصراف"
    },
    toolbar: {
      showOnPageScrollEnd: true,
      showOnPageScrollTop: true,
      hideOnPageScroll: false,
    }
  }
}
